import React from 'react';
import { useInView } from 'react-intersection-observer';

/**
 * One motion flourish: a short fade-and-rise on section entry, once.
 * `prefers-reduced-motion` is handled in CSS (.reveal is forced visible),
 * and the hero never uses it, so first paint is instant.
 */
const Reveal = ({ children, className = '' }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.08 });

  return (
    <div ref={ref} className={`reveal ${inView ? 'revealed' : ''} ${className}`.trim()}>
      {children}
    </div>
  );
};

export default Reveal;
